import { SerializedConstructor } from '@langchain/core/load/serializable';

import { cloneDeep, has, merge, omit, set } from 'lodash-es';
import { useCallback } from 'react';

import { applySecret } from '@/Pages/Playground/utils/Playground.utils';

import {
  DEFAULT_CHAT_MODEL_CONSTRUCTOR,
  MODEL_SECRETS,
} from '../../../Playground.constants';
import { useInferManifestFromRunCallback } from '../../../components/manifest/serialized/ManifestConstructor';

export function useUpdateModelManifest(
  manifest?: SerializedConstructor,
  setManifest?: (manifest: SerializedConstructor) => void
) {
  const inferManifest = useInferManifestFromRunCallback();
  const updateModelManifest = useCallback(
    (settings: SerializedConstructor) => {
      if (!setManifest || !manifest) return;
      let inferredManifest = inferManifest(settings);

      if (!inferredManifest) return;
      // these two keys get added in the inferManifestFromRun function, but unneeded
      inferredManifest = omit(inferredManifest, [
        'name',
        'kwargs.cache',
      ]) as SerializedConstructor;

      if (has(manifest.kwargs, 'last')) {
        const updatedManifest = cloneDeep(manifest);
        set(updatedManifest, 'kwargs.last', inferredManifest);
        setManifest(updatedManifest);
      } else {
        setManifest(merge({}, manifest, inferredManifest));
      }
    },
    [manifest, setManifest, inferManifest]
  );

  const resetToDefault = useCallback(() => {
    updateModelManifest(
      applySecret(
        DEFAULT_CHAT_MODEL_CONSTRUCTOR,
        MODEL_SECRETS[DEFAULT_CHAT_MODEL_CONSTRUCTOR.id.join('/')]
      )
    );
  }, [updateModelManifest]);

  return { updateModelManifest, resetToDefault };
}
